(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CustomerGroupCustom', CustomerGroupCustom);

    CustomerGroupCustom.$inject = ['$resource'];

    function CustomerGroupCustom($resource) {


        var getAllCompanyCustomerGroups = function () {

            var resourceUrl = 'api/get-all-company-customer-groups';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var getCustomerGroupsByCurrentCompany = function () {

            var resourceUrl = 'api/customer-groups-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getAllCompanyCustomerGroups: getAllCompanyCustomerGroups,
            getCustomerGroupsByCurrentCompany: getCustomerGroupsByCurrentCompany

        };
    }
})();
